import { render, staticRenderFns } from "./GenerateYearTables.vue?vue&type=template&id=98234996"
import script from "./GenerateYearTables.vue?vue&type=script&lang=js"
export * from "./GenerateYearTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98234996')) {
      api.createRecord('98234996', component.options)
    } else {
      api.reload('98234996', component.options)
    }
    module.hot.accept("./GenerateYearTables.vue?vue&type=template&id=98234996", function () {
      api.rerender('98234996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/rate_tables/GenerateYearTables.vue"
export default component.exports